import { CardElement, CardElementProps } from "@stripe/react-stripe-js";
import React, { type FC } from "react";

export type PaymentCardInputProps = CardElementProps & {};

export const PaymentCardInput: FC<PaymentCardInputProps> = (props) => {
  return (
    <div className="border rounded-md h-10 px-2 shadow-sm">
      <CardElement
        {...props}
        options={{
          hideIcon: true,
          disableLink: true,
          style: {
            base: {
              fontSize: "1.25rem",
              lineHeight: "36px",
            },
          },
          ...props.options,
        }}
      />
    </div>
  );
};
